// Утилиты для оптимизации производительности

// Дебаунс для оптимизации событий
export const debounce = (func, wait) => {
    let timeout;
    return function executedFunction(...args) {
        const later = () => {
            clearTimeout(timeout);
            func(...args);
        };
        clearTimeout(timeout);
        timeout = setTimeout(later, wait);
    };
};

// Троттлинг для оптимизации скролла
export const throttle = (func, limit) => {
    let inThrottle;
    return function () {
        const args = arguments;
        const context = this;
        if (!inThrottle) {
            func.apply(context, args);
            inThrottle = true;
            setTimeout(() => inThrottle = false, limit);
        }
    };
};

// Оптимизация скролла
export const optimizeScroll = () => {
    let ticking = false;

    const updateScroll = () => {
        // Здесь можно добавить логику для обработки скролла
        ticking = false;
    };

    const requestTick = () => {
        if (!ticking) {
            requestAnimationFrame(updateScroll);
            ticking = true;
        }
    };

    window.addEventListener('scroll', requestTick, { passive: true });
};

// Оптимизация ресайза окна
export const optimizeResize = () => {
    const handleResize = debounce(() => {
        // Здесь можно добавить логику для обработки изменения размера
        console.log('Window resized');
    }, 250);

    window.addEventListener('resize', handleResize, { passive: true });
};

// Предзагрузка критических ресурсов
export const preloadCriticalResources = () => {
    // Предзагружаем критические CSS
    const criticalCSS = document.createElement('link');
    criticalCSS.rel = 'preload';
    criticalCSS.href = '/static/css/main.css';
    criticalCSS.as = 'style';
    document.head.appendChild(criticalCSS);

    // Предзагружаем критические шрифты
    const criticalFont = document.createElement('link');
    criticalFont.rel = 'preload';
    criticalFont.href = 'https://fonts.googleapis.com/css2?family=Open+Sans:wght@300;400;600;700&display=swap';
    criticalFont.as = 'style';
    document.head.appendChild(criticalFont);
};

// Инициализация всех оптимизаций производительности
export const initPerformanceOptimizations = () => {
    optimizeScroll();
    optimizeResize();
    preloadCriticalResources();

    // Отключаем анимации для пользователей с предпочтением уменьшенного движения
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
        document.documentElement.style.setProperty('--animation-duration', '0.01ms');
    }
};
